<template>
	<v-template>
		<v-row justify="center">
			<v-col cols="12" sm="6" no-gutters class="pa-2">
				<v-sheet class="pa-2">
					<v-row>
						<v-col cols="12">
							<v-img max-height="80" :src="require('@/assets/sii-imagotipo.svg')" contain class="mb-2"/>
						</v-col>
						<v-col cols="12" class="text-center">
							<v-divider>
								<!-- divisor horizontal -->
							</v-divider>
						</v-col>
						<v-col cols="12" class="text-center">
							<span class="text-h6 grey--text text--darken-2">
								Identificación de contribuyentes
							</span>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-form v-model="formularioValido" @submit.prevent>
								<v-row dense>
									<v-col cols="12">
										RUT<br>
										<v-text-field 
											v-model="usuario"
											flat 
											hide-details="auto" :rules="usuarioValido"
											@input="rutFormatter"
											outlined
										>
										</v-text-field>
									</v-col>
									<v-col cols="12">
										CLAVE TRIBUTARIA<br>
										<v-text-field 
											v-model="contraseña"
											flat 
											:type="formConfig.showPass?'text':'password'" 
											hide-details="auto" 
											:rules="[validarContraseña]"
											:append-icon="formConfig.showPass?'visibility':'visibility_off'"
											@click:append="formConfig.showPass=!formConfig.showPass"
											outlined
										/>
									</v-col>
									<v-col cols="12">
										<v-alert
											v-if="sessionStatus.display"
											border="left"
											dark
											:color="sessionStatus.type"
											elevation="2"
										>
											{{sessionStatus.msg}}
										</v-alert>
									</v-col>
									<v-col cols="12">
										<v-btn
											large
											@click="iniciarSesion"
											:disabled="!formularioValido"
											:loading="$store.getters['usuario/isLoading']"
											block 
											depressed color="warning"
											class="text-h6 text-capitalize font-weight-bold"
										>
											Ingresar
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</v-col>
					</v-row>
				</v-sheet>
			</v-col>
			<v-snackbar
	      v-model="alert.display"
	      multi-line
	      :color="alert.type"
	    >
	      {{ alert.msg }}
	    </v-snackbar>
		</v-row>
		<v-row>
			<v-col class="text-center text-overline grey--text text--lighten-1">
				Versión {{version}}
			</v-col>
		</v-row>
	</v-template>
</template>

<script>

const SOFT_RUT_DV_REGEX = /^(\d+)-{0,1}([\d|k|K])$/;
import { rutValidate } from 'rut-helpers';
import { version } from '@/version';
import * as utils from '@/vessi.utils'

export default {
	name: 'iniciarSesion',
	computed: {
		usuarioValido(){
			return [
				v=>!!v || 'Introduzca un usuario',
				v=>rutValidate(v) || 'Ingrese un rut válido'
			];
		},
		isThereSavedRut(){
			return this.formConfig.hasToSaveRut && !!this.formConfig.loggedRut;
		}
	},
	data () {
		return {
			usuario: undefined,
			contraseña: undefined,
			formularioValido: false,
			alert:{
				display: false,
				type: 'error',
				msg: ''
			},
			formConfig:{
				showPass: false,
				hasLoggedRut: false,
				loggedRut: undefined,
				hasToSaveRut: false,
			},
			version: version,
			sessionStatus:{
				display: false,
				msg: '',
				type: 'warning'
			}
		};
	},
	methods: {
		iniciarSesion: async function(versionCheckeada=false) {

			this.alert.display = false;

			// para usar consistencia se quitan solo los puntos al rut
			let user = this.usuario.replace(/\./g,'');

			// if( user == '76431892-7' ){
			// 	this.$router.push({name: 'calculadora'});
			// 	this.$store.commit('usuario/auth_success', user, 'TEST_VESSI');
			// 	return;
			// }

			// try{
			// 	await this.$store.dispatch('version/checkVersion');
			// }catch(err){
			// 	console.error('err', err)
			// 	return;
			// }

			// return;

			if( this.formConfig.hasToSaveRut ){

				utils.ChangeStorage(localStorage);
				utils.SaveInStorage('loggedUser', user);
				utils.ChangeStorage();
			}else{
				utils.ChangeStorage(localStorage);
				utils.RemoveAttrInStorage('loggedUser');
				utils.ChangeStorage();
			}

			let params = {
				username: user,
				pass:this.contraseña,
				versionCheckeada: versionCheckeada === true
			}
			
			let respSignin = await this.$store.dispatch('usuario/signIn', params);
			
			if(respSignin===false){
				return;
			}if( this.$store.getters['usuario/authStatus'] === 'authenticated' ){

				if( !!respSignin )
					this.$router.push({name: 'calculadora'});
				else{
					this.showMessage('error', 'Ha ocurrido un error, vuelva a intentarlo más tarde');
				}
			}else{

				let error = this.$store.state.usuario.auth.error;

				if( error.hasOwnProperty('response') ){

					let msg = '';

					switch( error.response.status ){
						case 400:
							msg = 'Usuario y/o contraseña incorrectos.';
						break;
						break;
						case 404:
							msg = 'Usuario y/o contraseña incorrectos.';
						break;
						case 500:
							msg = 'Ha ocurrido un error, vuelva a intentarlo más tarde';
						break;
						default:
							msg = 'Ha ocurrido un error, vuelva a intentarlo más tarde';
					}

					this.showMessage('error', msg);
				}else{

					this.showMessage('error', error);
				}

			}

			this.checkLoggedRut();
		},
		validarContraseña: function(v) {
			return ((v !== undefined) && (v!== '')) || 'Introduzca una contraseña';
		},
		showMessage: function(type, msg){
			this.alert.display = true;
			this.alert.type = type;
			this.alert.msg = msg;
		},
		checkLoggedRut: function(){
			// funcion que checkea 
			return;
			// utils.ChangeStorage(localStorage);
			// let currentRut = utils.GetFromStorage('loggedUser');
			// utils.ChangeStorage();
			// let vm = this;
			// if(!!currentRut){
			// 	vm.formConfig.hasToSaveRut = true;
			// }

			// if(!!currentRut && vm.formConfig.hasToSaveRut){
			// 	vm.usuario = currentRut;
			// 	vm.formConfig.hasToSaveRut = true;
			// 	vm.formConfig.hasLoggedRut = true;
			// 	vm.formConfig.loggedRut = currentRut;
			// }else{
			// 	vm.formConfig.hasLoggedRut = false;
			// 	vm.formConfig.loggedRut = undefined;
			// }
		},
		async test(){
			console.log( await this.$store.dispatch('usuario/getSession') )
		},
		sessionHasExpired: function(){

			let vm = this;

			if( !vm.$store.state.auth )	return;

			let sessStatus = vm.$store.state.auth.status;
			let msgStatus = vm.$store.state.auth.error;

			if( sessStatus === 'expired' ){
				vm.sessionStatus.display = true;
				vm.sessionStatus.msg = msgStatus;
				vm.sessionStatus.type = 'warning';
			}
		},
		rutFormatter: function(evt){
			let rut = this.usuario;
			if( rut.length > 3 ){
				if( rut.includes('-') ){
					rut = rut.replace(/[-]/gm, '');
				}
				rut.replace(/[-]/gm, '').slice(0, -1)
				rut = `${rut.slice( 0, -1 )}-${rut.slice(-1)}`;
				this.usuario = rut;
			}
		}
	},
	mounted(){
		this.checkLoggedRut();
		this.sessionHasExpired();
	},
	filters: {
		formatRut(rut) {
			if (!rut) return '';


			if( RUT_SINPUNTOS.test(rut) ){
				let str = rut.replace(/\./g, '');
				return `${str.slice(0,-1)}-${str.slice(-1)}`;
			}
			else
				return rut;
	 }
	}

};
</script>
